/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


const actions = {

    // ////////////////////////////////////////////
    // SIDEBAR & UI UX
    // ////////////////////////////////////////////
    
    ////********************************************** New Create Actions ************************************** */ 

    updateApiHeader({commit},headers){
        commit('UPDATE_API_HEADER',headers)
    },
    updateReports({commit},reports){
        commit('REPORTS',reports)
    },
    updateSelectBaseStation({commit},baseStaiton){
        commit('SELECT_BASE_STATION',baseStaiton)
    },
    updateNavigationStatus({commit},navigationStatuss){
        commit('NAVIGATION_STATUS',navigationStatuss)
    },
    updateDetailNotification({commit},detailNotification){
        commit('DETAIL_NOTIFICATION',detailNotification)
    },
    updatePositionFixType({commit},positionfixType){
        commit('POSITION_FIX_TYPE',positionfixType)
    },
    updateShipTypes({commit},shipTypes){
        commit('SHIPTYPES' ,shipTypes)
    },
    updateMids({commit},mids){
        commit('MIDS',mids)

    },
    updateZones({commit},zones){
        commit('ZONES',zones)
    },
    updateVesselGroups({commit},vesselGroup){
        commit('VESSEL_GROUP',vesselGroup)
        
    },
    updateEventNotifications({commit},eventNotifications){
        commit('UPDATE_EVENT_NOTIFICATIONS',eventNotifications)
    },
    updateVessel({ commit }, dataVessel) {
        commit('UPDATE_VESSEL', dataVessel)
    },
    updateFilterVessel({ commit }, value) {
        commit('UPDATE_FILTER', value)
    },
    updateSelectVessel({ commit }, vessel) {
        commit('UPDATE_SELECT_VESSEL', vessel)
    },
    updataBaseStations({commit},baseStations){
        commit('UPDATE_BASE_STATIONS',baseStations)

    },
    vessels({commit},vessels){
        commit('VESSELS',vessels)
    },
    updateTitlePage({commit},title){
        commit('UPDATE_TITLE_PAGE',title)
    },
    updateEditZone({commit},zone){
        commit('UPDATE_EDIT_ZONE',zone)
    },
    updateActivListExciseTangker({ commit }, status) {
        commit('UPDATE_STATUS_ACTIVE_EXCISE', status)
    },
    updateListExciseTanker({commit},exciseList){
        commit('UPDATE_LIST_EXCISE_TANKER',exciseList)
    },

////********************************************** Old Create Actions ************************************** */     

    updateSidebarWidth({ commit }, width) {
        commit('UPDATE_SIDEBAR_WIDTH', width);
    },
    updateI18nLocale({ commit }, locale) {
        commit('UPDATE_I18N_LOCALE', locale);
    },
    toggleContentOverlay({ commit }) {
        commit('TOGGLE_CONTENT_OVERLAY');
    },
    updateTheme({ commit }, val) {
        commit('UPDATE_THEME', val);
    },



    // updateUserRole({ commit }, val) {
    //     commit('UPDATE_USER_ROLE', val);
    // },


    // ////////////////////////////////////////////
    // COMPONENT
    // //////////////////////////////////////////// 

    // VxAutoSuggest
    updateStarredPage({ commit }, payload) {
        commit('UPDATE_STARRED_PAGE', payload)
    },

    //  The Navbar
    arrangeStarredPagesLimited({ commit }, list) {
        commit('ARRANGE_STARRED_PAGES_LIMITED', list)
    },
    arrangeStarredPagesMore({ commit }, list) {
        commit('ARRANGE_STARRED_PAGES_MORE', list)
    },
    
    

}

export default actions